export const renderizarSeparadorBoletos = quantidadeSucessos => {
  if (!quantidadeSucessos) {
    return '';
  }

  const singular = quantidadeSucessos === 1;
  const titulo = `${singular ? 'Boleto' : 'Boletos'} gerado${singular ? '' : 's'} com sucesso`;
  const descricao = singular
    ? 'O boleto abaixo foi processado corretamente.'
    : 'Os boletos abaixo foram processados corretamente.';

  return `<div class="boletos-separator"><div class="boletos-separator-content"><h2 class="boletos-separator-title">${titulo}</h2><p class="boletos-separator-description">${descricao}</p></div></div>`;
};

export const renderizarLayoutBoletos = ({ estilos, tabelaErros, separador, conteudo }) =>
  `${estilos}<div class="boletos-layout"><div class="boletos-surface">${tabelaErros}${separador}${conteudo}</div></div>`;
